import React, { useState, useEffect } from 'react';
import { Table, Card, Typography, Space, Button, Modal, Form, Input, Checkbox, message } from 'antd';
import { UserOutlined, EditOutlined, KeyOutlined } from '@ant-design/icons';
import { baseurl } from '../../../components/lib/settings';

const { Title } = Typography;

const AdminUsuarios = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingUser, setEditingUser] = useState(null);
    const [form] = Form.useForm();

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const response = await baseurl.get('auth/list_users/');
            setUsers(response.data);
        } catch (error) {
            console.error("Erro ao carregar usuários", error);
            message.error("Erro ao carregar usuários.");
        } finally {
            setLoading(false);
        }
    };

    const showEditModal = (user) => {
        setEditingUser(user);
        form.setFieldsValue({
            password: '',
            voting_administrator: user.permissions?.voting_administrator || false,
            system_administrator: user.permissions?.system_administrator || false,
        });
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setEditingUser(null);
        form.resetFields();
    };

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            const payload = {
                permissions: {
                    voting_administrator: values.voting_administrator,
                    system_administrator: values.system_administrator,
                }
            };
            if (values.password) {
                payload.password = values.password;
            }

            await baseurl.post(`auth/update_user/${editingUser.id}/`, payload);
            message.success("Usuário atualizado com sucesso!");
            setIsModalVisible(false);
            setEditingUser(null);
            form.resetFields();
            fetchUsers(); // Refresh the list
        } catch (error) {
            console.error("Erro ao atualizar", error);
            message.error("Erro ao atualizar usuário.");
        }
    };

    const columns = [
        {
            title: 'Nome Completo',
            dataIndex: 'full_name',
            key: 'full_name',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Nome de Utilizador',
            dataIndex: 'user_name',
            key: 'user_name',
        },
        {
            title: 'Último Login',
            dataIndex: 'last_login',
            key: 'last_login',
            render: (text) => text ? new Date(text).toLocaleString('pt-PT') : 'Nunca',
        },
        {
            title: 'Permissões',
            key: 'permissions',
            render: (_, record) => {
                const perms = [];
                if (record.permissions?.system_administrator) perms.push("Sistema");
                if (record.permissions?.voting_administrator) perms.push("Votação");
                return perms.length > 0 ? perms.join(", ") : "Normal";
            }
        },
        {
            title: 'Ações',
            key: 'actions',
            render: (_, record) => (
                <Button type="primary" icon={<EditOutlined />} onClick={() => showEditModal(record)}>
                    Gerir
                </Button>
            ),
        }
    ];

    return (
        <div style={{ padding: '24px', minHeight: '80vh' }}>
            <div style={{ marginBottom: '24px' }}>
                <Space>
                    <UserOutlined style={{ fontSize: '28px', color: '#1890ff' }} />
                    <Title level={3} style={{ margin: 0, fontFamily: 'Montserrat, sans-serif' }}>
                        Lista de Usuários e Último Login
                    </Title>
                </Space>
            </div>
            
            <Card>
                <Table
                    columns={columns}
                    dataSource={users}
                    rowKey="id"
                    loading={loading}
                    pagination={{ pageSize: 15 }}
                />
            </Card>

            <Modal
                title={`Gerir Usuário: ${editingUser?.full_name}`}
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Salvar Alterações"
                cancelText="Cancelar"
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        label="Nova Palavra-passe"
                        name="password"
                        help="Deixe em branco se não quiser alterar a palavra-passe"
                    >
                        <Input.Password prefix={<KeyOutlined />} placeholder="Nova palavra-passe" />
                    </Form.Item>
                    <Form.Item name="voting_administrator" valuePropName="checked">
                        <Checkbox>Administrador de Votação</Checkbox>
                    </Form.Item>
                    <Form.Item name="system_administrator" valuePropName="checked">
                        <Checkbox>Administrador do Sistema</Checkbox>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default AdminUsuarios;
